(() => {
	angular.module('main').controller('SettingsController', SettingsController);

	SettingsController.$inject = ['$scope', '$location'];

	function SettingsController($scope, $location) {
		const settingList = [
			{
				title: 'Account & Subscription',
				icon: 'fi-account',
				url: '/settings/profile',
				description: 'Update your profile, password and subscription plan.',
				dataSection: 'accountAndSubscription'
			},
			{
				title: 'Company Information',
				icon: 'fi-company',
				url: '/settings/company',
				description:
					"Tell us your company information and we'll add it to your quotes and invoices.",
				dataSection: 'companyInformation'
			},
			{
				title: 'Company Users',
				icon: 'fi-users',
				url: '/settings/users',
				description:
					'Invite more users to your company account. The more the merrier!',
				dataSection: 'companyUsers'
			},
			{
				title: 'Currency & Taxes',
				icon: 'fi-currency-texes',
				url: '/settings/currency_and_taxes',
				description:
					'Tell us the currency that you trade in and your tax rates. These are applied to your quotes and invoices.',
				dataSection: 'currencyAndTaxes'
			},
			{
				title: 'Calendar Settings',
				icon: 'fi-calendar-settings',
				url: '/settings/google_cal',
				description:
					'Sync your Google Calendar with Studio Ninja so you have all your appointments in one place.',
				dataSection: 'calendarSettings'
			},
			{
				title: 'Payment Methods',
				icon: 'fi-payment-methods',
				url: '/settings/payment_methods',
				description:
					'How would you like your clients to pay? Set up different payment options here.',
				dataSection: 'paymentMethods'
			},
			{
				title: 'Payment Schedules & Reminders',
				icon: 'fi-payment-schedule',
				url: '/settings/payment_schedules',
				description:
					'What are your payment terms? Payment Schedules can divide one invoice into several payments.',
				dataSection: 'paymentSchedulesAndReminders'
			},
			{
				title: 'Products & Packages',
				icon: 'fi-products',
				url: '/settings/products_packages',
				description:
					'Create photography products or packages that can be applied easily to your quotes and invoices.',
				dataSection: 'productsAndPackages'
			},
			{
				title: 'Job Types',
				icon: 'fi-types',
				url: '/settings/job_types',
				description:
					'Customise job types and assign unique colours to manage the many different types of jobs you have.',
				dataSection: 'jobTypes'
			},
			{
				title: 'Email Settings',
				icon: 'fi-email-settings',
				url: '/settings/email_settings',
				description:
					'Set up your email server, sender name, reply-to email address and email signature.',
				dataSection: 'emailSettings'
			},
			{
				title: 'Email Templates',
				icon: 'fi-paper-plane',
				url: '/settings/email_templates',
				description:
					'Create email templates that can be applied easily to any correspondence with your clients.',
				dataSection: 'emailTemplates'
			},
			{
				title: 'Contract Templates',
				icon: 'fi-contract-templates',
				url: '/settings/contracts',
				description:
					'Create new contract templates and give your clients the ability to sign them electronically.',
				dataSection: 'contractTemplates'
			},
			{
				title: 'Questionnaire Templates',
				icon: 'fi-questionnaire-templates',
				url: '/settings/questionnaires',
				description:
					'Create new questionnaire templates and let your clients tell you more about who they are and what they want.',
				dataSection: 'questionnareTemplates'
			},
			{
				title: 'Contact Form',
				icon: 'fi-form',
				url: '/settings/contact_form',
				description:
					'Create a contact form that automatically adds a new client when an enquiry is received.',
				dataSection: 'contractForm'
			},
			{
				title: 'Workflows',
				icon: 'fi-workflows',
				url: '/settings/workflows',
				description:
					'Think of a workflow as a task list on steroids! Due dates can be assigned to tasks and best of all, you can send automated emails to your clients. Possibly the most important setting in your Ninja account.',
				dataSection: 'workflows'
			},
			{
				title: 'Integrations',
				icon: 'fi-integrate',
				url: '/settings/integrations',
				description:
					'Make Studio Ninja even better by integrating your favourite applications and tools you use for work.'
			},
			{
				title: 'Refer a Friend',
				icon: 'fi-refer',
				url: '/settings/refer',
				description:
					'Do you love using Studio Ninja? Refer a friend and we will take $5 off your subscription and $5 off theirs every month!'
			}
		];

		$scope.$on('$viewContentLoaded', () => {
			$scope.settingList = chunk(settingList, 3);
		});

		$scope.redirect = function(path) {
			$location.path(path);
		};

		function chunk(arr, cols) {
			const newArr = [];
			const max = arr.length;
			for (let i = 0; i < max; i += cols) {
				const row = arr.slice(i, i + cols);

				if (row.length != cols) {
					const emptyCols = cols - row.length;
					for (let j = 0; j < emptyCols; j += 1) {
						row.push({});
					}
				}

				newArr.push(row);
			}

			return newArr;
		}
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/settingsController.js